import { createVanIconComponent } from "./van"

const PlayCircleOutlined = createVanIconComponent("play-circle-o")
export default PlayCircleOutlined
